import { useEffect, useState } from 'react'

import type { NotificationFilter } from '@fv/models'

import { useUpdateNotificationCache } from './cache-modifiers'
import { NotificationDetailsPanel } from './NotificationDetailsPanel'
import { NotificationListing } from './NotificationListing'
import { NotificationsSideBar } from './NotificationsSideBar'
import type { Notification } from './queries'

export const NotificationsPage = () => {
  const [sideBarFilter, setSideBarFilter] = useState<NotificationFilter>({})
  const [sidebarId, setSideBarId] = useState<string>()
  const [activeNotification, setActiveNotification] = useState<string>()
  const updateNotificationCache = useUpdateNotificationCache()

  const clearActiveNotification = () => {
    setActiveNotification(undefined)
  }

  const handleSelect = (notification?: Notification) => {
    setActiveNotification(notification?._id)
    if (notification) {
      // updating the notification cache with a version of the new notification that way we can accurately display pinned/unpinned status in the details panel
      updateNotificationCache(notification)
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: false positive
  useEffect(() => {
    setActiveNotification(undefined)
  }, [sideBarFilter])

  return (
    <div className="shipper-page-fill shipper-grid-rows-single-fill grid grid-cols-[20rem_1fr_30rem] b1400:grid-cols-[19rem_1fr_25rem]">
      <NotificationsSideBar
        filterId={sidebarId}
        onFilterChange={(id, filter) => {
          setSideBarId(id)
          setSideBarFilter(filter)
        }}
      />
      <NotificationListing
        sideBarFilter={sideBarFilter}
        activeNotificationId={activeNotification}
        onSelect={handleSelect}
        onArchive={clearActiveNotification}
      />
      <NotificationDetailsPanel
        notificationId={activeNotification}
        onArchive={clearActiveNotification}
      />
    </div>
  )
}
